import request from '@/utils/request'

const smsCodeLog = {
  name: 'smsCodeLog',
  state: {
    isSmsCodeLogDetailLoading: false,
    smsCodeLogDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_SMSCODELOG_DETAIL_LOADING: (state, data) => {
      state.isSmsCodeLogDetailLoading = data
    },
    SET_MODULES_SMSCODELOG_DETAIL_DATA: (state, data) => {
      state.smsCodeLogDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    querySmsCodeLogDetailData({ commit }, id) {
      commit('SET_IS_MODULES_SMSCODELOG_DETAIL_LOADING', true)
      commit('SET_MODULES_SMSCODELOG_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/smsCodeLog/smsCodeLogDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_SMSCODELOG_DETAIL_LOADING', false)
          commit('SET_MODULES_SMSCODELOG_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_SMSCODELOG_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetSmsCodeLogDetailData({ commit }) {
      commit('SET_MODULES_SMSCODELOG_DETAIL_DATA', {})
    }
  }
}

export default smsCodeLog
